import { bankAccountResponseSchema } from '@/api/UK/paymentProvider/schemas';
import type {
  GetPaymentResponse,
  PaymentByIdResponse,
  SetupAccountPayload,
} from '@/api/UK/paymentProvider/types';
import { apiRequest } from '@/api/utils/api';

export const setupAccount = (payload: SetupAccountPayload) =>
  apiRequest({
    url: '/uk/payment-provider/account',
    method: 'POST',
    data: payload,
    schema: bankAccountResponseSchema,
  });

export const getBankAccount = () =>
  apiRequest({
    url: '/uk/payment-provider/account',
    method: 'GET',
    schema: bankAccountResponseSchema,
  });

export const setRepaymentDay = (repaymentDay: number) =>
  apiRequest({
    url: '/uk/payment-provider/account/repayment-day',
    method: 'PATCH',
    data: { repaymentDay },
    schema: bankAccountResponseSchema,
  });

export const setupDirectDebit = () =>
  apiRequest({
    url: '/uk/payment-provider/account/direct-debit-setup',
    method: 'POST',
    schema: bankAccountResponseSchema,
  });

export const initiateManualApproval = () =>
  apiRequest<''>({ url: '/uk/payment-provider/account/initiate-manual-approval', method: 'POST' });

export const getPayment = () =>
  apiRequest<GetPaymentResponse>({ url: '/uk/payment-provider/payment', method: 'GET' });

export const postManualPayment = (payload: { amount: number }) =>
  apiRequest<''>({ url: '/uk/payment-provider/payment/manual', method: 'POST', data: payload });

export const getPaymentById = (paymentInitiationId: string) =>
  apiRequest<PaymentByIdResponse>({
    url: `/uk/payment-provider/payment/${paymentInitiationId}`,
    method: 'GET',
  });
